import React from 'react';
import { Tile } from '@randajan/jet-react/dom/tile';
import { extendURL } from '@randajan/oauth2-client/tools';

import { Article } from '../../../elements/Article/Article';

import "./OpCard.scss";


const _blimpCounter = Math.floor(Date.now()/1000/60/60)-(200000);

export const OpCard = (props)=>{
    const { alias, avatar, desc } = props;
    
    return (
        <div className="OpCard paragraph wall -dark -border">
            <Tile className="avatar" caption={alias} src={avatar} />
            <Article>{desc?.replace("$$$", _blimpCounter.toLocaleString())}</Article>
        </div>
    )
}

